import { render, staticRenderFns } from "./CustomizationOffer.vue?vue&type=template&id=81088f2e&scoped=true"
import script from "./CustomizationOffer.vue?vue&type=script&lang=js"
export * from "./CustomizationOffer.vue?vue&type=script&lang=js"
import style0 from "./CustomizationOffer.vue?vue&type=style&index=0&id=81088f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81088f2e",
  null
  
)

export default component.exports